import { render, staticRenderFns } from "./AddStatusSetDialog.vue?vue&type=template&id=0b03aa0e"
import script from "@/views/School/StatusSets/AddStatusSetDialog/AddStatusSetDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/School/StatusSets/AddStatusSetDialog/AddStatusSetDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/School/StatusSets/AddStatusSetDialog/AddStatusSetDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports